import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-edit",
  "use": "foquz-icon-vue-edit-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol preserveAspectRatio=\"none\" overflow=\"visible\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-edit\"><path d=\"M13 4.536L9.464 1 1 9.464V13h3.536L13 4.536z\" stroke=\"var(--stroke-0, #667799)\" stroke-width=\"2\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol